import React from 'react';
import { useLanguage } from './index';
import { LangDebugSpan } from './LangDebugSpan';

interface TrProps {
  k: string;
  vars?: Record<string, string | number>;
  className?: string;
}

/**
 * <Tr k="tenant.field_name" /> — renders a translated string.
 * In showlang=true mode (superadmin only), wraps with key badge.
 * Use this for JSX contexts; use t() for attribute values (alt, placeholder, title).
 */
export const Tr: React.FC<TrProps> = ({ k, vars, className }) => {
  const { t, showLangMode } = useLanguage();
  const value = t(k, vars);

  if (showLangMode) {
    return <LangDebugSpan langKey={k} value={value} />;
  }

  return className ? <span className={className}>{value}</span> : <>{value}</>;
};
